<template>
  <a-card :bordered="false">
    <search-page-view
      ref="pageList"
      rowKey="orderNo"
      :itemNames="['name_1','name_2','name_3']"
      :columns="getColumns()"
      :col="4"
      :queryParams="queryParams"
      :requestPromise="getListPromise"
    >
      <a-form-item slot="name_1" label="下单时间" v-bind="searchItemLayout">
        <a-range-picker
          @change="onOrderDateChange"
          :value="selectedOrderDate"
          style="width: 100%"
        />
      </a-form-item>
      <a-form-item slot="name_2" label="订单号(魔方)" v-bind="searchItemLayout">
        <a-input v-model="queryParams.orderNo" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="name_3" label="订单号(途牛)" v-bind="searchItemLayout">
        <a-input v-model="queryParams.supplerOrderNo" placeholder="请输入"></a-input>
      </a-form-item>
      <template slot="orderAmount" slot-scope="rowItem">
        <span>￥{{ rowItem.record.orderAmount }}</span>
      </template>
    </search-page-view>
  </a-card>
</template>

<script>
import TuNiuMixins from '@/views/service/serviceProvider/tuNiuConnection/mixins/TuNiuMixins'

export default {
  name: 'TuNiuOrderList',
  mixins: [TuNiuMixins],
  data() {
    return {
      queryParams: {
        orderType: 33
      },
      searchItemLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 }
      },
      selectedOrderDate: undefined
    }
  },
  methods: {
    //日期变更
    onOrderDateChange(dates, dateStrArr) {
      this.selectedOrderDate = dates
      this.queryParams.startTime = dateStrArr[0] || undefined //下单开始时间
      this.queryParams.endTime = dateStrArr[1] || undefined //下单结束时间
    },
    getListPromise(params) {
      return this.getHttpServices().getOrderService().post('direct/getDirectOrderPage', params)
    },
    getColumns() {
      return [
        {
          title: '订单编号（魔方）',
          dataIndex: 'orderNo',
          width: '190px'
        },
        {
          title: '订单编号（途牛）',
          dataIndex: 'supplerOrderNo',
          width: '160px'
        },
        {
          title: '商品信息',
          dataIndex: 'proName'
        },
        {
          title: '订单金额',
          dataIndex: 'orderAmount',
          scopedSlots: { customRender: 'orderAmount' },
          width: '100px'
        },
        {
          title: '下单时间',
          dataIndex: 'createTime',
          width: '160px'
        },
        {
          title: '订单状态',
          dataIndex: 'statusStr',
          width: '100px'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
